import React, { useEffect, useState } from "react";
import { Navbar, Nav, Form, FormControl, Offcanvas, Button, Container, Row, Col } from "react-bootstrap";
import { FaShoppingCart, FaTrashAlt } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import Swal from "sweetalert2";
import axios from "axios";
import config from "../config.js";
import "../NewNav.scss";

// Logo
import logo from "../images/ORION.png";

// Consumer Product Images
import bulb1 from "../images/led2.jpg";
import bulb2 from "../images/downlight.jpg";
import bulb3 from "../images/panel1.jpg";
import bulb4 from "../images/adju.jpeg";
import bulb10 from "../images/8.jpg";
import bulb7 from "../images/cob.jpeg";
import bulb8 from "../images/batten1.jpg";
import bulb9 from "../images/tube-ligh1.jpg";
import consumer from "../images/led2.jpg";

// Professional Product Images
import spotlight from "../images/spot-light.jpg";
import floodlight from "../images/flood.jpg";
import streetlight from "../images/street-light.jpg";
import HighbayLights from "../images/high-bay.jpg";
import tseriess from "../images/tseriess-light.jpg";
import tubelig from "../images/tube-light.jpg";
import stadium from "../images/stadium-light.jpg";
import solar from "../images/solar.jpg";
import panel from "../images/panel1.jpg";
import professional from "../images/professional.webp";

// PCB and Smart
import pcb from "../images/homepcb.webp";
import ourProductImg from "../images/our_product.png";

import smart from "../images/smartlight.webp";

const NewNav = () => {
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [hoveredImage, setHoveredImage] = useState(null);
  const [showSlogan, setShowSlogan] = useState(false);
  const [consumerProducts, setConsumerProducts] = useState([]);
  const [professionalProducts, setProfessionalProducts] = useState([]);
  const [orderCount, setOrderCount] = useState(0);
  const [orderdata, setOrderdata] = useState([]);
   const [show, setShow] = useState(false);
     useEffect(() => {
      setTimeout(() => {
        setShowSlogan(true);
      }, 500);
    }, []);

  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);

  const categories = {
    consumer: {
      title: "Consumer",
      defaultImage: consumer,
      link: "/consumer-product",
      products: {
        "LED Bulbs": { id: 2, image: bulb1 },
        "LED Downlights": { id: 3, image: bulb2 },
        "LED Slim Panel Lights": { id: 4, image: bulb3 },
        "LED Adjustable Panel Lights": { id: 5, image: bulb4 },
        "LED Surface Panel": { id: 6, image: bulb10 },
        "LED COB": { id: 7, image: bulb7 },
        "LED Batten Light": { id: 8, image: bulb8 },
        "LED Tube Light": { id: 9, image: bulb9 },
      },
    },
    professional: {
      title: "Professional",
      defaultImage: professional,
      link: "/professional-product", // spelling corrected
      products: {
        "Street Light": { id: 10, image: streetlight },
        "High bay Lights": { id: 12, image: HighbayLights },
        "Panel Lights": { id: 13, image: panel },
        "Spot Lights": { id: 15, image: spotlight },
        "Flood Lights": { id: 11, image: floodlight },
        "LED Tube Light": { id: 16, image: tubelig },
        "LED Stadium Light": { id: 17, image: stadium },
        "LED Solar Street Lights": { id: 18, image: solar },
        "LED T Series Bulbs": { id: 14, image: tseriess },
      },
    },
  


PCB: {
  title: "PCB",
  defaultImage: pcb,
  link: "/Ourproduct",
  products: {
    "Our Product": { 
      image: ourProductImg ,
      link: "/Ourproduct"
    }
  }
},

  };

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}/api/getconsumer`)
      .then((res) => setConsumerProducts(Array.isArray(res.data) ? res.data : []))
      .catch(() => setConsumerProducts([]));

    axios.get(`${config.API_BASE_URL}/api/getprofessional`)
      .then((res) => setProfessionalProducts(Array.isArray(res.data) ? res.data : []))
      .catch(() => setProfessionalProducts([]));

    axios.get(`${config.API_BASE_URL}/api/getorder`)
      .then((res) => setOrderCount(res.data.order_count))
      .catch(console.error);

    axios.get(`${config.API_BASE_URL}/api/getorderbyid`)
      .then((res) => setOrderdata(res.data))
      .catch(console.error);
  }, []);

  const deleteOrder = (id) => {
    axios.get(`${config.API_BASE_URL}/api/order/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setOrderdata(orderdata.filter(order => order.id !== id));
          Swal.fire("Success", "Order deleted successfully!", "success").then(() => {
            window.location.reload();
          });
        }
      })
      .catch(() => {
        Swal.fire("Error", "Error deleting order", "error");
      });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isHomePage) setScrolled(window.scrollY > 50);
    };

    if (isHomePage) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [isHomePage]);

  const navbarClass = isHomePage ? (scrolled ? "scrolled" : "transparent") : "scrolled";

  return (
    <>
      <div className={`slogan-container ${showSlogan ? "show" : ""}`}>
        <p className="animated-slogan">"STEP INTO THE SPOTLIGHT OF SUPERIOR LIGHTING SOLUTIONS"</p>
      </div>
      <div className={`new-nav-wrapper ${isHomePage ? "" : "other-pages"}`}>
        <Navbar expand="lg" className={`custom-navbar ${navbarClass}`}>
          <Container>
            <Navbar.Brand href="/">
              <img src={logo} alt="QHlightings" className="logo mt-2" />
            </Navbar.Brand>
            <Navbar.Toggle />
            <Navbar.Collapse>
              <Nav className="mx-auto">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/new">What’s New</Nav.Link>

                {/* Product Dropdown */}
                <div className="nav-item-dropdown">
                  <Nav.Link href="/product" className="dropdown-toggle">Products</Nav.Link>
                  <div className="dropdown-menu-custom">
                    {Object.entries(categories).map(([key, section], index) => (
                      <div
                        key={key}
                        className="dropdown-section"
                        onMouseEnter={() => {
                          setHoveredCategory(key);
                          setHoveredImage(section.defaultImage);
                        }}
                        onMouseLeave={() => {
                          setHoveredCategory(null);
                          setHoveredImage(null);
                        }}
                      >
                        <div className="dropdown-image">
                          {hoveredCategory === key && hoveredImage && (
                            <img src={hoveredImage} alt={section.title} />
                          )}
                        </div>

                        <h4>
                          <a href={section.link} style={{ color: "white", textDecoration: "none" }}>
                            {section.title}
                          </a>
                        </h4>

                        <div className="category-content">
                          <ul>
                            {Object.entries(section.products || {}).map(([name, product]) => (
                            <li
                              key={name}
                              onMouseEnter={() => setHoveredImage(product.image)}
                            >
                              <a
                                href={product.link ? product.link : `/ProductList/${product.id}`}
                                style={{ color: "#444", textDecoration: "none" }}
                              >
                                {name}
                              </a>
                            </li>
                          ))}

                          </ul>
                        </div>

                        {index !== Object.keys(categories).length - 1 && <div className="divider"></div>}
                      </div>
                    ))}
                  </div>
                </div>

                <Nav.Link href="/project">Projects</Nav.Link>
                <Nav.Link href="/support">Support</Nav.Link>
                <Nav.Link href="/about">About</Nav.Link>
                <Nav.Link href="/newcontact">Contact Us</Nav.Link>
              </Nav>

              {/* Search */}
              <Form className="d-flex search-bar">
                <FormControl type="search" placeholder="Search..." className="me-2" aria-label="Search" />
              </Form>

              {/* Cart Icon */}
              <Nav.Link className="cart-icon" onClick={() => setShow(true)}>
                <FaShoppingCart />
                <span className="cart-badge">{orderCount}</span>
              </Nav.Link>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Offcanvas Cart */}
        <Offcanvas show={show} onHide={() => setShow(false)} placement="end" className="offcanvas-modal">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Shopping Cart</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="shopping-cart-page">
              <div className="cart-container">
                <Container>
                  <Row>
                    {orderdata.map((order, index) => (
                      <Col md={12} className="cart-item" key={index}>
                        <img src={order.img} alt="Product" />
                        <div className="cart-details">
                          <p className="size">Order Id: {order.orderid}</p>
                          <h2 className="heading-content mt-2">{order.product_model}</h2>
                          <p className="size">Status: {order.status}</p>
                          <p className="item-total">Item Total</p>
                        </div>
                        <div className="remove-section">
                          <div className="price">Rs. {order.price}</div>
                          <FaTrashAlt className="trash-icon" onClick={() => deleteOrder(order.orderid)} />
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </div>
            </div>
            <Button className="w-100 mt-3" style={{ border: 'none', backgroundImage: 'linear-gradient(to top, #525353, #373838, #111b21)' }}>
              <a href="/shopping-cart" className="shopping-btn text-white text-decoration-none" onClick={() => setShow(false)}>
                View Shopping
              </a>
            </Button>
            <Button className="w-100 mt-3" style={{ border: 'none', backgroundImage: 'linear-gradient(to top, #525353, #373838, #111b21)' }}>
              <a href="/checkoutpage" className="shopping-btn text-white text-decoration-none">
                Checkout
              </a>
            </Button>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default NewNav;